<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>email</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.email-builder' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <mat-form-field floatLabel="never" fxFlex="1 0 auto">
          <input [(ngModel)]="term" id="search" matInput  placeholder="{{'main.search' | translate}}">
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      @if (platforms && platforms.length && platforms.length > 1) {
        <div class="platform">
          <mat-form-field>
            <mat-select placeholder="{{'event.platforms' | translate}}" (selectionChange)="changePlatforms($event)"
              [value]="platforms[0].id">
              @for (plat of platforms; track plat.id) {
                <mat-option [value]="plat.id">
                  {{plat.title}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">
      @if (mails && mailTemplate) {
        <div class="email-builder">
          <section class="cardsEmail">
            @for (key of objectKeys(mails); track key) {
              @for (item of mails[key] | filter:term; track item) {
                @if (staticText[key]) {
                  <article class="card card-5">
                    <div class="title">
                      {{item.description}}
                    </div>
                    <div class="flip-container" [class.flipped]="mails[key]['isFlipped']">
                      <div class="flipper">
                        <div class="front">
                          <div class="edit-button">
                            <button style="margin-right: 2px" mat-fab (click)="toggleFlip([key])">
                              <mat-icon aria-label="edit">edit</mat-icon>
                            </button>
                            @if (isEquel(mails[key], mailsHistory[key])) {
                              <button mat-fab (click)="save(key, mails[key])">
                                <mat-icon aria-label="edit">save</mat-icon>
                              </button>
                            }
                          </div>
                          <div class="email" [innerHTML]="item.html">
                          </div>
                        </div>
                        <div class="back">
                          <div class="edit-button">
                            <button mat-fab (click)="toggleFlip([key]); changeHtml()">
                              <mat-icon aria-label="edit">mail</mat-icon>
                            </button>
                          </div>
                          <div class="back-container">
                            <mat-form-field class="example-full-width">
                              <input matInput placeholder="Subject" [(ngModel)]="item.subject">
                            </mat-form-field>
                            <mat-form-field class="example-full-width">
                              <textarea matInput placeholder="Text" [(ngModel)]="item.text1"></textarea>
                            </mat-form-field>
                            <b style="color: red">{{staticText[key]?.data[0]}}</b>
                            <mat-form-field class="example-full-width">
                              <textarea matInput placeholder="Text" [(ngModel)]="item.text2"></textarea>
                            </mat-form-field>
                            <b style="color: red">{{staticText[key]?.data[1]}}</b>
                            <mat-form-field class="example-full-width">
                              <textarea matInput placeholder="Text" [(ngModel)]="item.text3"></textarea>
                            </mat-form-field>
                            <b [innerHTML]="staticText[key]?.data[2]"></b>
                            @if (key === 'levelReach' || 'allCreditsAchieved' || 'fullCreditAccount') {
                              <mat-form-field class="example-full-width">
                                <textarea matInput placeholder="Text" [(ngModel)]="item.text4"></textarea>
                              </mat-form-field>
                            }
                            <mat-form-field class="example-full-width">
                              <textarea matInput placeholder="{{'button_text' | translate}}" [(ngModel)]="item.buttonText1"></textarea>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                }
              }
            }
          </section>
        </div>
      }
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>


